/* eslint-disable max-len */
import React, { Component } from 'react';
import { PulseLoader } from 'react-spinners';
import { FaAngleRight } from 'react-icons/fa';
import { compose, graphql } from 'react-apollo';
import { withAlert } from 'react-alert';
import { editOperatingHours } from '../../../../queries';

import OpeningHoursInputs from './Hours/Input';

import Content from './styles';
import { Row, Button } from '../../../../assets/styles';

class Opening extends Component {
  state = {
    openingHours: {
      monday: { start: '', end: '', closed: false },
      tuesday: { start: '', end: '', closed: false },
      wednesday: { start: '', end: '', closed: false },
      thursday: { start: '', end: '', closed: false },
      friday: { start: '', end: '', closed: false },
      saturday: { start: '', end: '', closed: false },
      sunday: { start: '', end: '', closed: false },
    },
    mondayError: false,
    tuesdayError: false,
    wednesdayError: false,
    thursdayError: false,
    fridayError: false,
    saturdayError: false,
    sundayError: false,
  }

  componentDidMount = () => {
    if (this.props.store.operatingHours) {
      const {
        Segunda,
        Terça,
        Quarta,
        Quinta,
        Sexta,
        Sábado,
        Domingo,
      } = this.props.store.operatingHours;

      this.setState({
        openingHours: {
          monday: { start: Segunda !== 'Fechado' ? Segunda.substring(0, 5) : '', end: Segunda !== 'Fechado' ? Segunda.substring(Segunda.length, Segunda.length - 5) : '', closed: Segunda === 'Fechado' },
          tuesday: { start: Terça !== 'Fechado' ? Terça.substring(0, 5) : '', end: Terça !== 'Fechado' ? Terça.substring(Terça.length, Terça.length - 5) : '', closed: Terça === 'Fechado' },
          wednesday: { start: Quarta !== 'Fechado' ? Quarta.substring(0, 5) : '', end: Quarta !== 'Fechado' ? Quarta.substring(Quarta.length, Quarta.length - 5) : '', closed: Quarta === 'Fechado' },
          thursday: { start: Quinta !== 'Fechado' ? Quinta.substring(0, 5) : '', end: Quinta !== 'Fechado' ? Quinta.substring(Quinta.length, Quinta.length - 5) : '', closed: Quinta === 'Fechado' },
          friday: { start: Sexta !== 'Fechado' ? Sexta.substring(0, 5) : '', end: Sexta !== 'Fechado' ? Sexta.substring(Sexta.length, Sexta.length - 5) : '', closed: Sexta === 'Fechado' },
          saturday: { start: Sábado !== 'Fechado' ? Sábado.substring(0, 5) : '', end: Sábado !== 'Fechado' ? Sábado.substring(Sábado.length, Sábado.length - 5) : '', closed: Sábado === 'Fechado' },
          sunday: { start: Domingo !== 'Fechado' ? Domingo.substring(0, 5) : '', end: Domingo !== 'Fechado' ? Domingo.substring(Domingo.length, Domingo.length - 5) : '', closed: Domingo === 'Fechado' },
        },
      });
    }
  }

  handleSubmit = async () => {
    await this.validateInputs();

    const {
      openingHours,
      mondayError,
      tuesdayError,
      wednesdayError,
      thursdayError,
      fridayError,
      saturdayError,
      sundayError,
    } = this.state;

    if (
      !mondayError
      && !tuesdayError
      && !wednesdayError
      && !thursdayError
      && !fridayError
      && !saturdayError
      && !sundayError
    ) {
      this.setState({ loading: true });

      const data = {
        operatingHours: {
          Segunda: !openingHours.monday.closed ? `${openingHours.monday.start} às ${openingHours.monday.end}` : 'Fechado',
          Terça: !openingHours.tuesday.closed ? `${openingHours.tuesday.start} às ${openingHours.tuesday.end}` : 'Fechado',
          Quarta: !openingHours.wednesday.closed ? `${openingHours.wednesday.start} às ${openingHours.wednesday.end}` : 'Fechado',
          Quinta: !openingHours.thursday.closed ? `${openingHours.thursday.start} às ${openingHours.thursday.end}` : 'Fechado',
          Sexta: !openingHours.friday.closed ? `${openingHours.friday.start} às ${openingHours.friday.end}` : 'Fechado',
          Sábado: !openingHours.saturday.closed ? `${openingHours.saturday.start} às ${openingHours.saturday.end}` : 'Fechado',
          Domingo: !openingHours.sunday.closed ? `${openingHours.sunday.start} às ${openingHours.sunday.end}` : 'Fechado',
        },
      };

      this.props
        .editOperatingHoursPortal({
          variables: {
            storeId: this.props.store.id,
            data,
          },
        })
        .then(async (res) => {
          this.props.saveStore(res.data.editOperatingHoursPortal);

          this.setState({ loading: false });

          this.props.alert.success('Informações salvas com sucesso');

          this.props.handleChangeState(data);
        });
    }
  }

  validateInputs = () => {
    const { openingHours } = this.state;

    this.setState({
      mondayError: false,
      tuesdayError: false,
      wednesdayError: false,
      thursdayError: false,
      fridayError: false,
      saturdayError: false,
      sundayError: false,
    });

    if (!openingHours.monday.closed) {
      if (openingHours.monday.start.length !== 5 || openingHours.monday.end.length !== 5) {
        this.setState({ mondayError: true });
      } else if (Number(openingHours.monday.start.substr(0, 2)) > 23 || Number(openingHours.monday.end.substr(0, 2)) > 23) {
        this.setState({ mondayError: true });
      } else if (Number(openingHours.monday.start.substr(5 - 2)) > 59 || Number(openingHours.monday.end.substr(5 - 2)) > 59) {
        this.setState({ mondayError: true });
      } else if (Number(openingHours.monday.start.substr(0, 2)) > Number(openingHours.monday.end.substr(0, 2))) {
        this.setState({ mondayError: true });
      } else if (Number(openingHours.monday.start.substr(0, 2)) === Number(openingHours.monday.end.substr(0, 2))) {
        if (Number(openingHours.monday.start.substr(5 - 2)) >= Number(openingHours.monday.end.substr(5 - 2))) {
          this.setState({ mondayError: true });
        }
      }
    }

    if (!openingHours.tuesday.closed) {
      if (openingHours.tuesday.start.length !== 5 || openingHours.tuesday.end.length !== 5) {
        this.setState({ tuesdayError: true });
      } else if (Number(openingHours.tuesday.start.substr(0, 2)) > 23 || Number(openingHours.tuesday.end.substr(0, 2)) > 23) {
        this.setState({ tuesdayError: true });
      } else if (Number(openingHours.tuesday.start.substr(5 - 2)) > 59 || Number(openingHours.tuesday.end.substr(5 - 2)) > 59) {
        this.setState({ tuesdayError: true });
      } else if (Number(openingHours.tuesday.start.substr(0, 2)) > Number(openingHours.tuesday.end.substr(0, 2))) {
        this.setState({ tuesdayError: true });
      } else if (Number(openingHours.tuesday.start.substr(0, 2)) === Number(openingHours.tuesday.end.substr(0, 2))) {
        if (Number(openingHours.tuesday.start.substr(5 - 2)) >= Number(openingHours.tuesday.end.substr(5 - 2))) {
          this.setState({ tuesdayError: true });
        }
      }
    }

    if (!openingHours.wednesday.closed) {
      if (openingHours.wednesday.start.length !== 5 || openingHours.wednesday.end.length !== 5) {
        this.setState({ wednesdayError: true });
      } else if (Number(openingHours.wednesday.start.substr(0, 2)) > 23 || Number(openingHours.wednesday.end.substr(0, 2)) > 23) {
        this.setState({ wednesdayError: true });
      } else if (Number(openingHours.wednesday.start.substr(5 - 2)) > 59 || Number(openingHours.wednesday.end.substr(5 - 2)) > 59) {
        this.setState({ wednesdayError: true });
      } else if (Number(openingHours.wednesday.start.substr(0, 2)) > Number(openingHours.wednesday.end.substr(0, 2))) {
        this.setState({ wednesdayError: true });
      } else if (Number(openingHours.wednesday.start.substr(0, 2)) === Number(openingHours.wednesday.end.substr(0, 2))) {
        if (Number(openingHours.wednesday.start.substr(5 - 2)) >= Number(openingHours.wednesday.end.substr(5 - 2))) {
          this.setState({ wednesdayError: true });
        }
      }
    }

    if (!openingHours.thursday.closed) {
      if (openingHours.thursday.start.length !== 5 || openingHours.thursday.end.length !== 5) {
        this.setState({ thursdayError: true });
      } else if (Number(openingHours.thursday.start.substr(0, 2)) > 23 || Number(openingHours.thursday.end.substr(0, 2)) > 23) {
        this.setState({ thursdayError: true });
      } else if (Number(openingHours.thursday.start.substr(5 - 2)) > 59 || Number(openingHours.thursday.end.substr(5 - 2)) > 59) {
        this.setState({ thursdayError: true });
      } else if (Number(openingHours.thursday.start.substr(0, 2)) > Number(openingHours.thursday.end.substr(0, 2))) {
        this.setState({ thursdayError: true });
      } else if (Number(openingHours.thursday.start.substr(0, 2)) === Number(openingHours.thursday.end.substr(0, 2))) {
        if (Number(openingHours.thursday.start.substr(5 - 2)) >= Number(openingHours.thursday.end.substr(5 - 2))) {
          this.setState({ thursdayError: true });
        }
      }
    }

    if (!openingHours.friday.closed) {
      if (openingHours.friday.start.length !== 5 || openingHours.friday.end.length !== 5) {
        this.setState({ fridayError: true });
      } else if (Number(openingHours.friday.start.substr(0, 2)) > 23 || Number(openingHours.friday.end.substr(0, 2)) > 23) {
        this.setState({ fridayError: true });
      } else if (Number(openingHours.friday.start.substr(5 - 2)) > 59 || Number(openingHours.friday.end.substr(5 - 2)) > 59) {
        this.setState({ fridayError: true });
      } else if (Number(openingHours.friday.start.substr(0, 2)) > Number(openingHours.friday.end.substr(0, 2))) {
        this.setState({ fridayError: true });
      } else if (Number(openingHours.friday.start.substr(0, 2)) === Number(openingHours.friday.end.substr(0, 2))) {
        if (Number(openingHours.friday.start.substr(5 - 2)) >= Number(openingHours.friday.end.substr(5 - 2))) {
          this.setState({ fridayError: true });
        }
      }
    }

    if (!openingHours.saturday.closed) {
      if (openingHours.saturday.start.length !== 5 || openingHours.saturday.end.length !== 5) {
        this.setState({ saturdayError: true });
      } else if (Number(openingHours.saturday.start.substr(0, 2)) > 23 || Number(openingHours.saturday.end.substr(0, 2)) > 23) {
        this.setState({ saturdayError: true });
      } else if (Number(openingHours.saturday.start.substr(5 - 2)) > 59 || Number(openingHours.saturday.end.substr(5 - 2)) > 59) {
        this.setState({ saturdayError: true });
      } else if (Number(openingHours.saturday.start.substr(0, 2)) > Number(openingHours.saturday.end.substr(0, 2))) {
        this.setState({ saturdayError: true });
      } else if (Number(openingHours.saturday.start.substr(0, 2)) === Number(openingHours.saturday.end.substr(0, 2))) {
        if (Number(openingHours.saturday.start.substr(5 - 2)) >= Number(openingHours.saturday.end.substr(5 - 2))) {
          this.setState({ saturdayError: true });
        }
      }
    }

    if (!openingHours.sunday.closed) {
      if (openingHours.sunday.start.length !== 5 || openingHours.sunday.end.length !== 5) {
        this.setState({ sundayError: true });
      } else if (Number(openingHours.sunday.start.substr(0, 2)) > 23 || Number(openingHours.sunday.end.substr(0, 2)) > 23) {
        this.setState({ sundayError: true });
      } else if (Number(openingHours.sunday.start.substr(5 - 2)) > 59 || Number(openingHours.sunday.end.substr(5 - 2)) > 59) {
        this.setState({ sundayError: true });
      } else if (Number(openingHours.sunday.start.substr(0, 2)) > Number(openingHours.sunday.end.substr(0, 2))) {
        this.setState({ sundayError: true });
      } else if (Number(openingHours.sunday.start.substr(0, 2)) === Number(openingHours.sunday.end.substr(0, 2))) {
        if (Number(openingHours.sunday.start.substr(5 - 2)) >= Number(openingHours.sunday.end.substr(5 - 2))) {
          this.setState({ sundayError: true });
        }
      }
    }
  }

  handleDeliveryChange = (field, value) => {
    this.setState(state => ({
      delivery: {
        ...state.delivery,
        [field]: value,
      },
    }));
  }

  handleOpeningHoursChange = (day, hour) => {
    this.setState(state => ({
      openingHours: {
        ...state.openingHours,
        [day]: hour,
      },
    }));
  }

  onFocus = (type) => {
    this.setState({ [type]: true });
  }

  onBlur = (type) => {
    this.setState({ [type]: false });
  }

  render() {
    const { loading } = this.state;

    return (
      <Content>
        <Row>
          <h2 style={{ marginBottom: 5 }}>Horário de entrega</h2>
          <p className="subtitle">
            {'Estes são os horários em que sua loja ficará disponível para receber pedidos.'}
          </p>
          <OpeningHoursInputs
            handleOpeningHoursChange={this.handleOpeningHoursChange}
            state={this.state}
          />
          <Button type="submit" disabled={loading} onClick={this.handleSubmit}>
            {!loading ? (
              <span>
                {'Salvar'}
                <FaAngleRight className="fa fa-angle-right" />
              </span>
            ) : (
              <PulseLoader
                sizeUnit="px"
                size={7}
                color="#FFFFFF"
                loading={loading}
                style={{ paddingLeft: '25px' }}
              />
            )}
          </Button>
        </Row>
      </Content>
    );
  }
}

export default compose(
  withAlert(),
  graphql(editOperatingHours, { name: 'editOperatingHoursPortal' }),
)(Opening);
